import { render, staticRenderFns } from "./TesteCartaModal.vue?vue&type=template&id=7a814a4a&scoped=true"
import script from "./TesteCartaModal.vue?vue&type=script&lang=js"
export * from "./TesteCartaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a814a4a",
  null
  
)

export default component.exports